import { connect } from 'react-redux';
import PriceCalculator from './PriceCalculator';
import { bindActionCreators } from 'redux';
import { getFormValues, reset, destroy } from 'redux-form';

const FORM_NAME = 'ProductReceiptDetails';
const mapStateToProps = (state) => ({
    formValues: getFormValues(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        resetForm: () => reset(FORM_NAME),
        destroyForm: () => destroy(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PriceCalculator);
